import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";
import Brand from "@/components/Brand";

export default function PortalHeader({ title, right }) {
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-30 backdrop-blur-xl bg-[#141C16]/80 border-b border-[#D2A853]/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-brand">
          <Brand variant="submark" className="h-9 w-9" />
          <span className="hidden sm:block font-display tracking-[0.2em] text-[#E8E9E3] text-sm">PAID DEWZ</span>
        </Link>
        <div className="flex items-center gap-6">
          {title && <span className="hidden md:block overline text-[#A3A8A4]">{title}</span>}
          {right}
          {user && (
            <button
              onClick={logout}
              className="flex items-center gap-2 text-[#A3A8A4] hover:text-[#D2A853] transition-colors"
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4" strokeWidth={1.4} />
              <span className="hidden sm:inline overline">Logout</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
